module.exports = ".col-no-border td{border:0}.col-no-border th{border:0}\n"